import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  UUS

  <span style="color:#85c1dc;">**FI:**</span>
  UUSI

  <span style="color:#85c1dc;">**RU:**</span>
  НОВЫЙ
*/
/* @__NO_SIDE_EFFECTS__ */
const m1785 = msg(
  mf`UUS`,
  mf`UUSI`,
  mf`НОВЫЙ`,
)

export { m1785 as 'w.module.product.label_new' }